<template>
    <login-confirmation-form></login-confirmation-form>
</template>

<script>
import LoginConfirmationForm from "@/components/Auth/LoginConfirmationForm.vue";

export default {
    name: "LoginConfirmation",
    components: {LoginConfirmationForm},
}
</script>

<style scoped>

</style>